import { FC, useState } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useStyles } from './styles';
import { BaseTreeInputProps } from './types';
import { BaseTreeExplorer } from 'components/BaseTreeExplorer';
import { ClickAwayListener, Input, FormGroup } from '@material-ui/core';
import SubdirectoryArrowLeftIcon from '@material-ui/icons/SubdirectoryArrowLeft';
import { observer } from 'mobx-react-lite';

export const BasePathInput: FC<BaseTreeInputProps> = observer(({ onChange, disabled }) => {
  const classes = useStyles();
  const {
    baseTreeExplorerStore: {
      inputHistory: { base },
      setCurrentHistory,
    },
  } = useStore();

  const [openBaseExplorer, setOpenBaseExplorer] = useState<boolean>(false);

  const toggleBaseExplorer = () => {
    setOpenBaseExplorer((prev) => !prev);
    setCurrentHistory('input');
  };

  const handleCloseBaseExplorer = () => setOpenBaseExplorer(false);

  const handleOpenBaseExplorer = () => {
    setOpenBaseExplorer(true);
    setCurrentHistory('input');
  };

  const value = ((): string => {
    onChange(base);
    return base;
  })();

  return (
    <ClickAwayListener onClickAway={handleCloseBaseExplorer}>
      <div
        className={classes.main}
        onDoubleClick={handleCloseBaseExplorer}
        onMouseOver={handleOpenBaseExplorer}
        onMouseLeave={handleCloseBaseExplorer}>
        <p>Base</p>
        <Input
          className={classes.inputWide}
          placeholder='Base'
          value={value}
          disabled={disabled}
          //onChange={handleChange}
          onClick={toggleBaseExplorer}
          endAdornment={<SubdirectoryArrowLeftIcon style={{ color: 'grey' }} />}
        />
        {openBaseExplorer ? (
          <FormGroup className={classes.dropdown}>
            <BaseTreeExplorer />
          </FormGroup>
        ) : null}
      </div>
    </ClickAwayListener>
  );
});
